import React from 'react';
import { ExceptionManager, LogManagerConsole } from 'Core/logManager';
import {
  copyToClipboard,
  convertToKPHWithDecimals,
} from 'Core/data/Helpers';
import { Button } from 'Components';

// Global styles
import styles from 'Assets/sass/core/vars.scss';
import { getFormattedField } from '../../../../core/data/Helpers';

const getOdometerBaseNumeric = (base) => {
  if (base === null || base === undefined || base === '') return null;
  const n = Number(base);
  return Number.isFinite(n) ? n : null;
};

const getOdometerOffsetAdditive = (offset) => {
  if (offset === null || offset === undefined || offset === '') return 0;
  const n = Number(offset);
  return Number.isFinite(n) ? n : 0;
};

export const getOdometerValue = (unit, isKph, hideMeasure) => {
  const {
    useEcuOdometer = false,
    ecuEngineOdometer,
    offsetEcuEngineOdometer,
    engineOdometer,
    offsetEngineOdometer,
  } = unit;

  const base = useEcuOdometer ? ecuEngineOdometer : engineOdometer;
  const offset = useEcuOdometer ? offsetEcuEngineOdometer : offsetEngineOdometer;

  const baseNum = getOdometerBaseNumeric(base);
  if (baseNum == null) {
    if (hideMeasure) return -1;
    return `0 ${isKph ? "km" : "mi"}`;
  }

  let odometer;
  try {
    const total = baseNum + getOdometerOffsetAdditive(offset);

    if (!Number.isFinite(total)) {
      odometer = 0;
    } else if (isKph) {
      odometer = convertToKPHWithDecimals(total, 2);
    } else {
      odometer = Number(total.toFixed(2));
    }
  } catch (exc) {
    ExceptionManager(exc, "common", "getOdometerValue");
  }

  if (hideMeasure) return Number.isFinite(odometer) ? odometer : -1;

  return Number.isFinite(odometer)
    ? `${odometer.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${isKph ? "km" : "mi"}`
    : "N/A";
};

export const getOdometerLabel = ({ engineOdometer, ecuEngineOdometer, useEcuOdometer = false, offsetEcuEngineOdometer, offsetEngineOdometer, isKph }) => {
  const base = useEcuOdometer ? ecuEngineOdometer : engineOdometer;
  const offset = useEcuOdometer ? offsetEcuEngineOdometer : offsetEngineOdometer;

  const baseNum = getOdometerBaseNumeric(base);
  if (baseNum == null) {
    return 0;
  }

  let odometer;
  try {
    const total = baseNum + getOdometerOffsetAdditive(offset);

    if (!Number.isFinite(total)) {
      odometer = 0;
    } else if (isKph) {
      odometer = convertToKPHWithDecimals(total, 2);
    } else {
      odometer = Number(total.toFixed(2));
    }
  } catch (exc) {
    ExceptionManager(exc, "common", "OdometerView");
  }

  return Number.isFinite(odometer) ? odometer : 0;
};

  const OdometerView = ({
    label,
    useEcuOdometer = false,
    ecuEngineOdometer,
    offsetEcuEngineOdometer,
    engineOdometer,
    offsetEngineOdometer,
    isKph,
  }) => {
    LogManagerConsole(
      "OdometerView",
      label,
      useEcuOdometer,
      ecuEngineOdometer,
      offsetEcuEngineOdometer,
      engineOdometer,
      offsetEngineOdometer
    );

    const odometer = getOdometerLabel({
      engineOdometer,
      ecuEngineOdometer,
      useEcuOdometer,
      offsetEcuEngineOdometer,
      offsetEngineOdometer,
      isKph,
    });

    const isValid = Number.isFinite(odometer);
    const formattedValue = isValid
      ? odometer.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "N/A";

    return (
        <div>
            <span style={{ paddingRight: 8 }}>
                {
                    useEcuOdometer && (
                     <span
                        className="ecuChip"
                        style={{ background: styles.ecu }}
                    >
                        ECU
                    </span>
                )}
                {isValid ? `${formattedValue} ${isKph ? "km" : "mi"}` : "N/A"}
            </span>
            <Button
                type="icon"
                icon="content_copy"
                onClick={() =>
                  copyToClipboard(
                    isValid
                      ? getFormattedField(formattedValue, isKph ? "km" : "mi")
                      : "N/A"
                  )
                }
                fontSize="inherit"
                className="btn-no-padding hover-item"
            />
        </div>
    );
  };

export default OdometerView